import { TrackingEvent } from '@caresend/types';
import { getLocalTimeZone } from '@caresend/utils';
import { defineComponent, ref, computed } from 'vue';
import GoogleMaps from '../../../../../../assets/icons/google-maps.svg.js';
import __vue_component__$6 from '../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__ from './shared/AdditionalLocationInstructionsModal.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';
import __vue_component__$2 from '../../../../WaypointCompliance/LateArrivalReasonModal.vue.js';
import __vue_component__$4 from '../../../../WaypointCompliance/LocationDeviationReasonModal.vue.js';
import __vue_component__$5 from '../../../../WaypointCompliance/RunningLateReasonModal.vue.js';
import __vue_component__$1 from '../../../../../ui/Icon.vue.js';
import __vue_component__$3 from '../../../../../ui/Loading/Loading.vue.js';
import 'firebase/auth';
import { getItineraryDrivingEstimateRequest } from '../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../database/firebaseConfig/init.js';
import '../../../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import { copyToClipboard } from '../../../../../../functions/clipboard.js';
import '../../../../../../functions/configuration/icons.js';
import '../../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../../functions/tracking/index.js';
import { trackEvent } from '../../../../../../functions/tracking/tracking.js';
import { getStore } from '../../../../../../store/helpers/initStore.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { openMapDirection } from '../../../../../../functions/location.js';

var script = defineComponent({
    name: 'InlineTransit',
    components: {
        AdditionalLocationInstructionsModal: __vue_component__,
        Icon: __vue_component__$1,
        LateArrivalReasonModal: __vue_component__$2,
        Loading: __vue_component__$3,
        LocationDeviationReasonModal: __vue_component__$4,
        RunningLateReasonModal: __vue_component__$5,
        ButtonComponent: __vue_component__$6,
        GoogleMaps,
    },
    props: {
        waypointID: {
            type: String,
            required: true,
        },
    },
    setup(props, { emit }) {
        const store = getStore();
        const portalStore = usePortalStore();
        const isLoading = ref(false);
        const waypoint = computed(() => portalStore.waypoints.get(props.waypointID));
        const address = computed(() => { var _a; return (_a = waypoint.value) === null || _a === void 0 ? void 0 : _a.computed.formattedAddress; });
        const additionalInstructions = computed(() => { var _a; return (_a = waypoint.value) === null || _a === void 0 ? void 0 : _a.location.additionalInstructions; });
        const isCaptureLateReasonAlertOpened = ref(false);
        const isCaptureLocationReasonAlertOpened = ref(false);
        const isCaptureManualLateReasonAlertOpened = ref(false);
        const additionalInstructionsOpen = ref(false);
        const delayReason = ref();
        const isTooFar = ref(false);
        const tooFarReason = ref();
        const validateArrival = async () => {
            var _a, _b;
            isTooFar.value = portalStore.waypoints.getters.deviationFailure(props.waypointID);
            if (isTooFar.value) {
                isCaptureLocationReasonAlertOpened.value = true;
                return;
            }
            isLoading.value = true;
            await trackEvent(store, TrackingEvent.ARRIVED_AT_WAYPOINT, {
                nurseID: (_a = store.state.auth.user) === null || _a === void 0 ? void 0 : _a.id,
                itineraryID: (_b = waypoint.value) === null || _b === void 0 ? void 0 : _b.itineraryID,
                waypointID: props.waypointID,
            }, true);
            emit('complete');
            isLoading.value = false;
        };
        const selectManualDelayReason = async (reason) => {
            var _a, _b, _c, _d;
            if (!((_a = waypoint.value) === null || _a === void 0 ? void 0 : _a.itineraryID))
                return;
            isLoading.value = true;
            const leaveFrom = (_c = (_b = store.state.auth.user) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.current;
            const drivingEstimate = await getItineraryDrivingEstimateRequest({
                itineraryID: waypoint.value.itineraryID,
                leaveFrom,
                waypointID: props.waypointID,
            });
            const delayInfo = {
                newDrivingEstimate: (drivingEstimate || 0) / 1000,
                reason: reason,
                timeZone: store.getters['auth/getUserTimeZone'],
                timestamp: Date.now(),
            };
            portalStore.waypoints.setChildOf(props.waypointID, 'transitInfo/delayInfo', delayInfo, true);
            await trackEvent(store, TrackingEvent.WAYPOINT_ARRIVAL_DELAY, {
                nurseID: (_d = store.state.auth.user) === null || _d === void 0 ? void 0 : _d.id,
                itineraryID: waypoint.value.itineraryID,
                waypointID: props.waypointID,
                drivingEstimate: delayInfo.newDrivingEstimate,
                delayReason: reason,
            }, true);
            isCaptureManualLateReasonAlertOpened.value = false;
            isLoading.value = false;
        };
        const selectArrivalDelayReason = async (reason) => {
            var _a, _b;
            isCaptureLateReasonAlertOpened.value = false;
            delayReason.value = reason;
            if (isTooFar.value) {
                isCaptureLocationReasonAlertOpened.value = true;
                return;
            }
            if (!((_a = waypoint.value) === null || _a === void 0 ? void 0 : _a.itineraryID))
                return;
            isLoading.value = true;
            await trackEvent(store, TrackingEvent.ARRIVED_AT_WAYPOINT, {
                nurseID: (_b = store.state.auth.user) === null || _b === void 0 ? void 0 : _b.id,
                itineraryID: waypoint.value.itineraryID,
                waypointID: props.waypointID,
                delayReason: delayReason.value,
            }, true);
            emit('complete');
            isLoading.value = false;
        };
        const selectDeviationReason = async (reason) => {
            var _a, _b;
            if (!((_a = waypoint.value) === null || _a === void 0 ? void 0 : _a.itineraryID))
                return;
            isLoading.value = true;
            isCaptureLocationReasonAlertOpened.value = false;
            tooFarReason.value = reason;
            // Save location deviation reason to the waypoint
            portalStore.waypoints.setChildOf(props.waypointID, 'transitInfo/locationDeviation', {
                reason,
                timestamp: Date.now(),
                timeZone: getLocalTimeZone(),
            }, true);
            await trackEvent(store, TrackingEvent.ARRIVED_AT_WAYPOINT, {
                nurseID: (_b = store.state.auth.user) === null || _b === void 0 ? void 0 : _b.id,
                itineraryID: waypoint.value.itineraryID,
                waypointID: props.waypointID,
                tooFarReason: tooFarReason.value,
            }, true);
            emit('complete');
            isLoading.value = false;
        };
        const copyAddress = () => {
            var _a;
            const copyTarget = (_a = address.value) === null || _a === void 0 ? void 0 : _a.join(', ');
            if (!copyTarget)
                return;
            copyToClipboard(copyTarget);
        };
        const openGoogleMaps = () => {
            var _a;
            if (!((_a = waypoint.value) === null || _a === void 0 ? void 0 : _a.location))
                return;
            openMapDirection(waypoint.value.location);
        };
        return {
            additionalInstructions,
            additionalInstructionsOpen,
            address,
            copyAddress,
            openGoogleMaps,
            isCaptureLateReasonAlertOpened,
            isCaptureLocationReasonAlertOpened,
            isCaptureManualLateReasonAlertOpened,
            isLoading,
            selectArrivalDelayReason,
            selectManualDelayReason,
            selectDeviationReason,
            validateArrival,
        };
    },
});

export { script as default };
